<div class="notification-center" (clickOutside)="closePanel()">
  <button class="notifications btn notification-bell" mat-button [title]="'Notifications' | translate" (click)="togglePanel()">
    <span class="notification-bell-icon">
      <i class="fas fa-bell fa-lg"></i>
      @if (unreadCount > 0) {
        <span class="notification-count">{{ displayCount }}</span>
      }
    </span>
  </button>

  @if (isPanelOpen) {
    <section class="notification-dropdown">
      <div class="dropdown-header">
        <h5>{{ 'Notifications' | translate }}</h5>
      </div>
      @if (suppressedLastHourCount > 0) {
        <div class="suppressed-indicator">
          {{ '{{count}} alerts suppressed in last hour' | translate: { count: suppressedLastHourCount } }}
        </div>
      }
      @if (topUnacknowledgedAlerts.length > 0) {
        <div class="alerts-list">
          @for (alert of topUnacknowledgedAlerts; track trackById($index, alert)) {
            <div
              class="alert-row"
              [ngClass]="{ 'is-acknowledged': alert.isAcknowledged }"
              (click)="openAlertDetails(alert)">
              <span class="severity-chip-wrapper" [ngClass]="alert.shouldPulse ? 'pulse' : ''">
                <app-severity-chip [severity]="alert.severity" [compact]="true"></app-severity-chip>
              </span>
              <div class="alert-content">
                <div class="alert-main-row">
                  <span class="parameter-name">{{ alert.parameterName }}</span>
                  <span class="alert-value">{{ alert.valueDisplay }}</span>
                </div>
                <div class="alert-meta-row">
                  <span class="site-sensor">{{ alert.siteSensorDisplay }}</span>
                  <span class="event-time">{{ alert.eventTime | dateFormat }}</span>
                </div>
              </div>
              @if (!alert.isAcknowledged) {
                <button
                  type="button"
                  class="btn btn-inline btn-ack"
                  (click)="acknowledgeAlert($event, alert.id)">
                  {{ 'Acknowledge' | translate }}
                </button>
              }
              @if (alert.isAcknowledged) {
                <span class="ack-label">{{ 'Acknowledged' | translate }}</span>
              }
            </div>
          }
        </div>
      } @else {
        <div class="no-alerts">{{ 'No active alerts' | translate }}</div>
      }
      <button type="button" class="view-all-link" (click)="openNotificationList()">
        {{ 'View All' | translate }}
      </button>
    </section>
  }
</div>

